import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const dialog = inject(MatDialog);
  
  // Token hozzáadása a kéréshez (ellenőrizzük, hogy localStorage elérhető-e)
  let token = null;
  if (typeof localStorage !== 'undefined') {
    token = localStorage.getItem('token');
  }
  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const isLoginRequest = req.url.includes('/auth/login');
      
      if (error.status === 401 && !isLoginRequest) {
        // 401 hiba esetén tisztítjuk a localStorage-t és irányítsuk át a login oldalra
        // DE csak ha már be vagyunk jelentkezve (van token)
        if (token) {
          console.log('401 hiba - Token érvénytelen, átirányítás a login oldalra');
          dialog.closeAll();
          localStorage.removeItem('token');
          localStorage.removeItem('userData');
          router.navigate(['/login']);
        }
      }
      
      // Inaktív fiók kezelése: 403 + "Inaktív fiók" → automatikus kijelentkezés
      if (error.status === 403 && !isLoginRequest && token) {
        const detail = error.error?.detail || '';
        if (detail.includes('Inaktív fiók')) {
          console.log('403 hiba - Inaktív fiók, automatikus kijelentkezés');
          dialog.closeAll();
          localStorage.removeItem('token');
          localStorage.removeItem('userData');
          router.navigate(['/login']);
        }
      }
      
      return throwError(() => error);
    })
  );
};
